import { checkUserSession, settings } from "../plugins/common.js";
import { deleteData, getData, getRawData, getCustomRawData, executeCustomAction, readData, searchQueryData, searchJsonData, updateData, updateFormData, writeData, writeFormData, getSchema } from "./database.js";

export var tablesData = {
	currentUser: null,
	currentLocation: null,
	currentDocument: null,
	currentReferenceItem: null,
	currentMeasureUnit: null,
	currentAdditionalBarcode: null,
	currentItem: null,
	currentSerial: null,
	currentStock: null,
	currentBranch: null,
	currentPlant:	null,
	currentCustomer: null,
	currentSupplier: null,
	currentAddresse: null,
	currentTransportMean: null,
	currentProjectTypology: null,
	currentProject: null,
	currentProjectRow: null,
	currentPick: null,
	currentTrack: null,
	currentPackageTypology: null,
	currentPackage: null,
	currentPrinter: null,
	currentPrintTemplate: null,
	printerActionResult: null,
	custoimActionResult: null,
	users:[],
	locations: [],
	documents: [],
	referenceItems: [],
	measureUnits: [],
	additionalBarcodes: [],
	items: [],
	serials: [],
	stocks: [],
	branches: [],
	plants:	[],
	customers:	[],
	suppliers:	[],
	addresses: [],
	transportMeans: [],
	projectTypologies: [],
	projects: [],
	projectRows: [],
	picks: [],
	tracks:[],
	packageTypologies: [],
	packages: [],
	printers: [],
	printTemplates: [],
}
export var tablesToBeRefreshed = {
	users: false,
	locations: false,
	documents: false,
	referenceItems: false,
	measureUnits: false,
	additionalBarcodes: false,
	items: false,
	serials: false,
	stocks:	false,
	branches: false,
	plants:	false,
	customers: false,
	suppliers: false,
	addresses: false,
	transportMeans: false,
	projectTypologies: false,
	projects: false,
	projectRows: false,
	picks: false,
	tracks: false,
	packageTypologies: false,
	packages: false,
	printers: false,
	printTemplates: false,
}
var retState = null

function pluralize(word) {
	if (word.endsWith('y')) return word.slice(0, -1) + 'ies';
	if (['s', 'x', 'z'].some(e => word.endsWith(e)) || ['ch', 'sh'].some(e => word.endsWith(e))) return word + 'es';
	return word + 's';
}

export async function hasPrinter() {
	await getData("printers")
	//.then(data => { (data.length > 0) ? settings.printerManagement = true : settings.printerManagement = false; tablesData.printers = data; retState =  true; })
	.then(data => { settings.printerManagement = (data.length > 0); tablesData.printers = data; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getUsers() { 
	await getData("users")
	.then(data => { tablesData.users = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getLocations() { 
	await getData("locations")
	.then(data => { tablesData.locations = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getDocuments() { 
	await getData("documents")
	.then(data => { tablesData.documents = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getReferenceItems() { 
	await getData("documents")
	.then(data => { tablesData.referenceItems = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getMeasureUnits() {
	await getData("measure_units")
	.then(data => { tablesData.measureUnits = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getAdditionalBarcodes() {
	await getData("additional_barcodes")
	.then(data => { tablesData.additionalBarcodes = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getItems() {
	await getData("items")
	.then(data => { tablesData.items = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getSerials() {
	await getData("serials")
	.then(data => { tablesData.serials = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getStocks() {
	await getData("stocks")
	.then(data => { tablesData.stocks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getBranches() {
	await getData("branches")
	.then(data => { tablesData.branches = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPlants() {
	await getData("plants")
	.then(data => { tablesData.plants = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getCustomers() {
	await getData("customers")
	.then(data => { tablesData.customers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getSuppliers() {
	await getData("suppliers")
	.then(data => { tablesData.suppliers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getAddresses() {
	await getData("addresses")
	.then(data => { tablesData.addresses = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getTransportMeans() {
	await getData("transport_means")
	.then(data => { tablesData.transportMeans = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getProjectTypologies() {
	await getData("project_typologies")
	.then(data => { tablesData.projectTypologies = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getProjects() {
	await getData("projects")
	.then(data => { tablesData.projects = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getProjectRows() {
	await getData("project_rows")
	.then(data => { tablesData.projectRows = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPicks() {
	await getData("picks")
	.then(data => { tablesData.picks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getTracks() {
	await getData("tracks")
	.then(data => { tablesData.tracks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPackageTypologies() {
	await getData("package_typologies")
	.then(data => { tablesData.packageTypologies = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPackages() {
	await getData("packages")
	.then(data => { tablesData.packages = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPrinters() {
	await getData("printers")
	.then(data => { tablesData.printers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPrintTemplates() {
	await getData("print_templates")
	.then(data => { tablesData.printTemplates = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawUsers() { 
	await getRawData("users")
	.then(data => { tablesData.users = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawLocations() { 
	await getRawData("locations")
	.then(data => { tablesData.locations = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawDocuments() { 
	await getRawData("documents")
	.then(data => { tablesData.documents = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawReferenceItems() { 
	await getRawData("documents")
	.then(data => { tablesData.referenceItems = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawMeasureUnits() {
	await getRawData("measure_units")
	.then(data => { tablesData.measureUnits = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawAdditionalBarcodes() {
	await getRawData("additional_barcodes")
	.then(data => { tablesData.additionalBarcodes = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawItems() {
	await getRawData("items")
	.then(data => { tablesData.items = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawSerials() {
	await getRawData("serials")
	.then(data => { tablesData.serials = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawStocks() {
	await getRawData("stocks")
	.then(data => { tablesData.stocks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawBranches() {
	await getRawData("branches")
	.then(data => { tablesData.branches = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPlants() {
	await getRawData("plants")
	.then(data => { tablesData.plants = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawCustomers() {
	await getRawData("customers")
	.then(data => { tablesData.customers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawSuppliers() {
	await getRawData("suppliers")
	.then(data => { tablesData.suppliers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawAddresses() {
	await getRawData("addresses")
	.then(data => { tablesData.addresses = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawTransportMeans() {
	await getRawData("transport_means")
	.then(data => { tablesData.transportMeans = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawProjectTypologies() {
	await getRawData("project_typologies")
	.then(data => { tablesData.projectTypologies = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawProjects() {
	await getRawData("projects")
	.then(data => { tablesData.projects = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawProjectRows() {
	await getRawData("project_rows")
	.then(data => { tablesData.projectRows = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPicks() {
	await getRawData("picks")
	.then(data => { tablesData.picks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawTracks() {
	await getRawData("tracks")
	.then(data => { tablesData.tracks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPackageTypologies() {
	await getRawData("package_typologies")
	.then(data => { tablesData.packageTypologies = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPackages() {
	await getRawData("packages")
	.then(data => { tablesData.packages = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPrinters() {
	await getRawData("printers")
	.then(data => { tablesData.printers = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getRawPrintTemplates() {
	await getRawData("print_templates")
	.then(data => { tablesData.printTemplates = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchDocuments(project_id = null, closed = null, partial = null) {
	let mySearch = {
		params: {
			// 'q[project_id_eq]': project_id,
			'q[parent_id_null]': true,
		}
	};
	(project_id != null)? mySearch.params['q[project_id_eq]'] = project_id : mySearch.params['q[project_id_null]'] = true;
	if (closed != null) mySearch.params['q[closed_true]'] = closed
	if (partial != null) mySearch.params['q[partial_true]'] = partial
	await searchQueryData("documents", mySearch)
	.then(data => { tablesData.documents = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchReferenceItems(project_id = null, parent_id = null, closed = null, partial = null) {
	let mySearch = {
		params: {
			// 'q[project_id_eq]': project_id,
			// 'q[parent_id_eq]': parent_id,
		}
	};
	(project_id != null)? mySearch.params['q[project_id_eq]'] = project_id : mySearch.params['q[project_id_null]'] = true;
	(parent_id != null)? mySearch.params['q[parent_id_eq]'] = parent_id : mySearch.params['q[parent_id_not_null]'] = true;
	if (closed != null) mySearch.params['q[closed_true]'] = closed
	if (partial != null) mySearch.params['q[partial_true]'] = partial
	await searchQueryData("documents", mySearch)
	.then(data => { tablesData.referenceItems = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchItems(has_serials = null, has_lots = null) {
	let mySearch = {
		params: {
			//'q[has_serials_true]': has_serials,
			//'q[has_lots_true]': has_lots,
		}
	};
	if (has_serials != null) mySearch.params['q[has_serials_true]'] = has_serials
	if (has_lots != null) mySearch.params['q[has_lots_true]'] = has_lots
	await searchQueryData("items", mySearch)
	.then(data => { tablesData.items = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchSerials(item_id) {
	let mySearch = {
		params: {
			'q[item_id_eq]': item_id,
		}
	};
	await searchQueryData("serials", mySearch)
	.then(data => { tablesData.serials = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchProjects(project_typology_id, store = null, prepared = null, delivered = null, closed = null, partial = null, suspended = null, user_id = null, sort_field = null) {
	let mySearch = {
		params: {
			'q[project_typology_id_eq]': project_typology_id,
		}
	};
	if (store != null) mySearch.params['q[store_true]'] = store
	if (prepared != null) mySearch.params['q[prepared_true]'] = prepared
	if (delivered != null) mySearch.params['q[delivered_true]'] = delivered
	if (closed != null) mySearch.params['q[closed_true]'] = closed
	if (partial != null) mySearch.params['q[partial_true]'] = partial
	if (suspended != null) mySearch.params['q[suspended_true]'] = suspended
	if (user_id != null) mySearch.params['q[user_id_eq]'] = user_id
	if (sort_field != null) mySearch.params['q[s]'] = sort_field
	await searchQueryData("projects", mySearch)
	.then(data => { tablesData.projects = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchProjectRows(project_id, location_id = null, filter = null, package_id = null) {
	let mySearch = {
		params: {
			'q[project_id_eq]': project_id,
		}
	};
	if (location_id) mySearch.params['q[location_id_eq]'] = location_id
	if (filter) mySearch = filter
	if (package_id) mySearch.params['q[package_id_eq]'] = package_id
	await searchQueryData("project_rows", mySearch)
	.then(data => { tablesData.projectRows = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchPicks(project_id, location_id = null, filter = null) {
	let mySearch = {
		params: {
			'q[project_id_eq]': project_id,
		}
	};
	if (location_id) mySearch.params['q[location_id_eq]'] = location_id
	if (filter) mySearch = filter
	await searchQueryData("picks", mySearch)
	.then(data => { tablesData.picks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchPicksWithDocuments(project_id, document_id = null) {
	let mySearch = {
		params: {
			'q[project_id_eq]': project_id,
		}
	};
	!document_id ? mySearch.params['q[document_id_null]'] = true  : mySearch.params['q[document_id_eq]'] = document_id;
	await searchQueryData("picks", mySearch)
	.then(data => { tablesData.picks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchTracks(project_row_id) {
	let mySearch = {
		params: {
			'q[project_row_id_eq]': project_row_id,
		}
	};
	await searchQueryData("tracks", mySearch)
	.then(data => { tablesData.tracks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchPackages(project_id = null, closed = null, shipped = null) {
	let mySearch = {
		params: {
		}
	};
	!project_id ? mySearch.params['q[project_id_null]'] = true  : mySearch.params['q[project_id_eq]'] = project_id;
	if (closed != null) mySearch.params['q[closed_eq]'] = closed
	if (shipped != null) mySearch.params['q[shipped_eq]'] = shipped
	await searchQueryData("packages", mySearch)
	.then(data => { tablesData.packages = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchRawProjects(project_typology_id) {
	// COALESCE(to_jsonb(pt), '[]'::jsonb) AS project_typology torna [] se non c'è, invece di null, per evitare problemi in frontend
	// to_jsonb(pt)	AS project_typology tornerebbe null se non c'è, invece di {}, ma in questo caso non da problemi, anzi è più corretto, perché se non c'è la project_typology, è giusto che sia null e non un oggetto vuoto che potrebbe confondere
	let query = `
		WITH full_projects AS (
			SELECT
				p.*,
				COALESCE(to_jsonb(pt), '{}'::jsonb) AS project_typology,
				COALESCE(to_jsonb(c), '{}'::jsonb) AS customer,
				COALESCE(to_jsonb(s), '{}'::jsonb) AS supplier,
				COALESCE(to_jsonb(u), '{}'::jsonb) AS user,
				COALESCE(to_jsonb(tm), '{}'::jsonb) AS transport_mean,
				COALESCE(to_jsonb(a), '{}'::jsonb) AS address,
				COALESCE(to_jsonb(b), '{}'::jsonb) AS branch,
				COALESCE(to_jsonb(pl), '{}'::jsonb) AS plant
			FROM projects p
			LEFT JOIN project_typologies pt ON pt.id = p.project_typology_id
			LEFT JOIN customers c ON c.id  = p.customer_id
			LEFT JOIN suppliers s ON s.id = p.supplier_id
			LEFT JOIN users u ON u.id = p.user_id
			LEFT JOIN users tm ON tm.id = p.transport_mean_id
			LEFT JOIN users a ON a.id = p.address_id
			LEFT JOIN users b ON b.id = p.branch_id
			LEFT JOIN users pl ON pl.id = p.plant_id
			WHERE p.project_typology_id = ${project_typology_id}
			ORDER BY p.name
		)

		SELECT json_agg(fp)
		AS result
		FROM full_projects fp
	`;

	await getCustomRawData(query.replace(/[\n\r]+/g, ' ').trim())
	.then(data => { tablesData.projects = data; retState = true; })
	.catch(error => { checkUserSession(error, "warning"); retState = false; });
	return retState;
}
export async function searchRaw(table_name, project_typology_id) {
	let schema;
	try {
		schema = await getSchema(table_name);
	} catch (error) {
		checkUserSession(error, "warning");
		return false;
	}

	const { belongs_to = [], has_many = [] } = schema.projects.associations;

	const joinClauses = belongs_to.map(assoc =>
		`LEFT JOIN ${pluralize(assoc)} ${assoc} ON ${assoc}.id = p.${assoc}_id`
	);

	const selectBelongsTo = belongs_to.map(assoc =>
		`COALESCE(to_jsonb(${assoc}), '{}'::jsonb) AS ${assoc}`
	);

	//valutare se omettere in quanto appesantisce
	const selectHasMany = has_many.map(assoc =>
		`(SELECT COALESCE(json_agg(t), '{}'::jsonb) FROM ${assoc} t WHERE t.project_id = p.id) AS ${assoc}`
	);

	//valutare se cambiare ${[...selectBelongsTo, ...selectHasMany].join(',\n\t\t\t\t')}
	//con `${...selectBelongsTo.join(',\n\t\t\t\t')}
	const query = `
		WITH full_projects AS (
			SELECT
				p.*,
				${[...selectBelongsTo, ...selectHasMany].join(',\n\t\t\t\t')}
			FROM projects p
			${joinClauses.join('\n\t\t\t')}
			WHERE p.project_typology_id = ${project_typology_id}
			ORDER BY p.name
		)

		SELECT json_agg(fp)
		AS result
		FROM full_projects fp
	`;

	await getCustomRawData(query.replace(/[\n\r]+/g, ' ').trim())
	.then(data => { tablesData.projects = data; retState = true; })
	.catch(error => { checkUserSession(error, "warning"); retState = false; });
	return retState;
}
export async function jsonSearchItems(json) {
	await searchJsonData("items", json)
	.then(data => { tablesData.items = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function jsonSearchSerials(json) {
	await searchJsonData("serials", json)
	.then(data => { tablesData.serials = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function jsonSearchProjects(json) {
	await searchJsonData("projects", json)
	.then(data => { tablesData.projects = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function jsonSearchProjectRows(json) {
	await searchJsonData("project_rows", json)
	.then(data => { tablesData.projectRows = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function jsonSearchPicks(json) {
	await searchJsonData("picks", json)
	.then(data => { tablesData.picks = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createLocation(objData, refreshData = true) {
	await writeData("locations", objData)
	.then(async (data) => {	if (refreshData == true) await getLocations();	tablesData.currentLocation = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createDocument(objData, refreshData = true) {
	await writeData("documents", objData)
	.then(async (data) => {	if (refreshData == true) await getDocuments();	tablesData.currentDocument = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createAdditionalBarcode(objData, refreshData = true) {
	await writeData("additional_barcodes", objData)
	.then(async (data) => {	if (refreshData == true) await getAdditionalBarcodes();	tablesData.currentAdditionalBarcode = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createItem(objData, refreshData = true) {
	await writeData("items", objData)
	.then(async (data) => {	if (refreshData == true) await getItems();	tablesData.currentItem = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createSerial(objData, refreshData = true) {
	await writeData("serials", objData)
	.then(async (data) => {	if (refreshData == true) await getSerials();	tablesData.currentSerial = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createProject(objData, refreshData = true) {
	await writeData("projects", objData)
	.then(async (data) => {	if (refreshData == true) await getProjects();	tablesData.currentProject = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createProjectRow(objData, refreshData = true) {
	await writeData("project_rows", objData)
	.then(async (data) => {	if (refreshData == true) await getProjectRows();	tablesData.currentProjectRow = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createPick(objData, refreshData = true) {
	await writeData("picks", objData)
	.then(async (data) => {	if (refreshData == true) await getPicks();	tablesData.currentPick = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createTrack(objData, refreshData = true) {
	await writeData("tracks", objData)
	.then(async (data) => {	if (refreshData == true) await getTracks();	tablesData.currentTrack = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createPackage(objData, refreshData = true) {
	await writeData("packages", objData)
	.then(async (data) => {	if (refreshData == true) await getPackages();	tablesData.currentPackage = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createItemFormData(objData, refreshData = true) {
	await writeFormData("items", objData)
	.then(async (data) => {	if (refreshData == true) await getItems();	tablesData.currentItem = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createPackageFormData(objData, refreshData = true) {
	await writeFormData("packages", objData)
	.then(async (data) => {	if (refreshData == true) await getPackages();	tablesData.currentPackage = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getUser(id) {
	await readData("users", id)
	.then(data => { tablesData.currentUser = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getLocation(id) {
	await readData("locations", id)
	.then(data => { tablesData.currentLocation = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getDocument(id) {
	await readData("documents", id)
	.then(data => { tablesData.currentDocument = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getReferenceItem(id) {
	await readData("documents", id)
	.then(data => { tablesData.currentReferenceItem = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getAdditionalBarcode(id) {
	await readData("additional_barcodes", id)
	.then(data => { tablesData.currentAdditionalBarcode = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getItem(id) {
	await readData("items", id)
	.then(data => { tablesData.currentItem = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getSerial(id) {
	await readData("serials", id)
	.then(data => { tablesData.currentSerial = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getStock(id) {
	await readData("stocks", id)
	.then(data => { tablesData.currentStock = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getBranch(id) {
	await readData("branches", id)
	.then(data => { tablesData.currentBranch = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPlant(id) {
	await readData("plants", id)
	.then(data => { tablesData.currentPlant = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getCustomer(id) {
	await readData("customers", id)
	.then(data => { tablesData.currentCustomer = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getSupplier(id) {
	await readData("suppliers", id)
	.then(data => { tablesData.currentSupplier = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getAddresse(id) {
	await readData("addresses", id)
	.then(data => { tablesData.currentAddresse = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getTransportMean(id) {
	await readData("transport_means", id)
	.then(data => { tablesData.currentTransportMean = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getProject(id) {
	await readData("projects", id)
	.then(data => { tablesData.currentProject = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getProjectRow(id) {
	await readData("project_rows", id)
	.then(data => { tablesData.currentProjectRow = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPick(id) {
	await readData("picks", id)
	.then(data => { tablesData.currentPick = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPackageTypology(id) {
	await readData("package_typologies", id)
	.then(data => { tablesData.currentPackageTypology = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPackage(id) {
	await readData("packages", id)
	.then(data => { tablesData.currentPackage = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPrinter(id) {
	await readData("printers", id)
	.then(data => { tablesData.currentPrinter = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function getPrintTemplate(id) {
	await readData("print_templates", id)
	.then(data => { tablesData.currentPrintTemplate = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateUser(id, objData, refreshData = true) {
	await updateData("users", id, objData)
	.then(async (data) => {	if (refreshData == true) await getUsers();	tablesData.currentUser = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateDocument(id, objData, refreshData = true) {
	await updateData("documents", id, objData)
	.then(async (data) => {	if (refreshData == true) await getDocuments();	tablesData.currentDocument = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateItem(id, objData, refreshData = true) {
	await updateData("items", id, objData)
	.then(async (data) => {	if (refreshData == true) await getItems();	tablesData.currentItem = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateSerial(id, objData, refreshData = true) {
	await updateData("serials", id, objData)
	.then(async (data) => {	if (refreshData == true) await getSerials();	tablesData.currentSerial = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateProject(id, objData, refreshData = true) {
	await updateData("projects", id, objData)
	.then(async (data) => {	if (refreshData == true) await getProjects();	tablesData.currentProject = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateProjectRow(id, objData, refreshData = true) {
	await updateData("project_rows", id, objData)
	.then(async (data) => {	if (refreshData == true) await getProjectRows();	tablesData.currentProjectRow = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updatePick(id, objData, refreshData = true) {
	await updateData("picks", id, objData)
	.then(async (data) => {	if (refreshData == true) await getPicks();	tablesData.currentPick = data;	retState = true;})
	.catch(error => { checkUserSession(error, "warning"); retState = false; });
	return retState;
}
export async function updatePackage(id, objData, refreshData = true) {
	await updateData("packages", id, objData)
	.then(async (data) => {	if (refreshData == true) await getPackages();	tablesData.currentPackage = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updatePrinter(id, objData, refreshData = true) {
	await updateData("printers", id, objData)
	.then(async (data) => {	if (refreshData == true) await getPrinters();	tablesData.currentPrinter = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updateItemFormData(id, objData, refreshData = true) {
	await updateFormData("items", id, objData)
	.then(async (data) => {	if (refreshData == true) await getItems();	tablesData.currentItem = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function updatePackageFormData(id, objData, refreshData = true) {
	await updateFormData("packages", id, objData)
	.then(async (data) => {	if (refreshData == true) await getPackages();	tablesData.currentPackage = data;	retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchLocation(name) {
	let mySearch = {
		params: {
			'q[name_eq]': name,
		}
	};
	await searchQueryData("locations", mySearch)
	.then(data => { tablesData.currentLocation = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchDocument(project_id, name = null, code = null) {
	let mySearch = {
		params: {
			'q[project_id_eq]': project_id,
		}
	};
	if (name) mySearch.params['q[name_eq]'] = name
	if (code) mySearch.params['q[code_eq]'] = code
	await searchQueryData("documents", mySearch)
	.then(data => { tablesData.currentDocument = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchAdditionalBarcode(code) {
	let mySearch = {
		params: {
			'q[code_eq]': code,
		}
	};
	await searchQueryData("additional_barcodes", mySearch)
	.then(data => { tablesData.currentAdditionalBarcode = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchItem(code = null, barcode = null) {
	let mySearch = {
		params: {
		}
	};
	if (code) mySearch.params['q[code_eq]'] = code
	if (barcode) mySearch.params['q[barcode_eq]'] = barcode
	await searchQueryData("items", mySearch)
	.then(data => { tablesData.currentItem = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchSerial(code = null, name = null) {
	let mySearch = {
		params: {
		}
	};
	if (code) mySearch.params['q[code_eq]'] = code
	if (name) mySearch.params['q[name_eq]'] = name
	await searchQueryData("serials", mySearch)
	.then(data => { tablesData.currentSerial = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchItemSerial(item_id, code, reference_date = null) {
	let mySearch = {
		params: {
			'q[item_id_eq]': item_id,
			'q[code_eq]': code,
		}
	};
	(reference_date != null)? mySearch.params['q[reference_date_eq]'] = reference_date : mySearch.params['q[reference_date_null]'] = true;
	await searchQueryData("serials", mySearch)
	.then(data => { tablesData.currentSerial = (data.length > 0) ? data[0] : null; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
// Returns the project row of the item with that serial/lot (serial_id null: row without serial/lot), optionally in a location or in a pick; null if not found, false on error
export async function searchItemProjectRow(project_id, item_id, serial_id, location_id = null, pick_id = null) {
	let projectRow = false;
	let mySearch = {
		params: {
			'q[project_id_eq]': project_id,
			'q[item_id_eq]': item_id,
		}
	};
	(serial_id != null)? mySearch.params['q[serial_id_eq]'] = serial_id : mySearch.params['q[serial_id_null]'] = true;
	if (location_id) mySearch.params['q[location_id_eq]'] = location_id
	if (pick_id) mySearch.params['q[pick_id_eq]'] = pick_id
	await searchQueryData("project_rows", mySearch)
	.then(data => { projectRow = (data.length > 0) ? data[0] : null; })
	.catch(error => { checkUserSession(error, "warning"); projectRow = false; });
	return projectRow;
}
// Returns the id of the serial/lot of the item with that code and reference date (null for serials), creating it if not exists; null on error
export async function getOrCreateItemSerialId(item_id, code, reference_date = null) {
	if (await searchItemSerial(item_id, code, reference_date) == false) return null;
	if (!tablesData.currentSerial) {
		let objData = {
			serial: {
				item_id: item_id,
				code: code,
				reference_date: reference_date,
			}
		};
		if (await createSerial(objData, false) == false) return null;
	}
	return tablesData.currentSerial ? tablesData.currentSerial.id : null;
}
export async function searchBranch(code) {
	let mySearch = {
		params: {
			'q[code_eq]': code,
		}
	};
	await searchQueryData("branches", mySearch)
	.then(data => { tablesData.currentBranch = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchProjectTypology(title) {
	let mySearch = {
		params: {
			'q[title_eq]': title,
		}
	};
	await searchQueryData("project_typologies", mySearch)
	.then(data => { tablesData.currentProjectTypology = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchProject(name) {
	let mySearch = {
		params: {
			'q[name_eq]': name,
		}
	};
	await searchQueryData("projects", mySearch)
	.then(data => { tablesData.currentProject = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchPick(project_row_id) {
	let mySearch = {
		params: {
			'q[project_row_id_eq]': project_row_id,
		}
	};
	await searchQueryData("picks", mySearch)
	.then(data => { tablesData.currentPick = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function searchPrinter(isDefaulPrinter = null, printerName = null, printerPlantId = null) {
	let mySearch = {
		params: {
		}
	};
	if (isDefaulPrinter != null) mySearch.params['q[default_eq]'] = isDefaulPrinter
	if (printerName != null) mySearch.params['q[name_eq]'] = printerName
	if (printerPlantId != null) mySearch.params['q[plant_id_eq]'] = printerPlantId
	await searchQueryData("printers", mySearch)
	.then(data => { tablesData.currentPrinter = data[0]; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function createPdfFromPackage(package_id) {
	let myFilter = {
		'package_id': package_id,
	};
	await executeCustomAction("packages", "save_pdf_report_to_smb_share", myFilter)
	.then(data => { tablesData.custoimActionResult = data; retState =  true;})
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });
	return retState;
}
export async function deleteDocument(id, refreshData = true) {
	await deleteData("documents", id)
	.then(async () => {	if (refreshData == true) await getDocuments();	tablesData.currentDocument = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deleteItem(id, refreshData = true) {
	await deleteData("items", id)
	.then(async () => {	if (refreshData == true) await getItems();	tablesData.currentItem = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deleteSerial(id, refreshData = true) {
	await deleteData("serials", id)
	.then(async () => {	if (refreshData == true) await getSerials();	tablesData.currentSerial = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deleteProject(id, refreshData = true) {
	await deleteData("projects", id)
	.then(async () => {	if (refreshData == true) await getProjects();	tablesData.currentProject = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deleteProjectRow(id, refreshData = true) {
	await deleteData("project_rows", id)
	.then(async () => {	if (refreshData == true) await getProjectRows();	tablesData.currentProjectRow = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deletePick(id, refreshData = true) {
	await deleteData("picks", id)
	.then(async () => {	if (refreshData == true) await getPicks();	tablesData.currentPick = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function deletePackage(id, refreshData = true) {
	await deleteData("packages", id)
	.then(async () => {	if (refreshData == true) await getPackages();	tablesData.currentPackage = null; retState =  true; })
	.catch(error => { checkUserSession(error, "warning"); retState =  false; });	
	return retState;
}
export async function executePrinterAction(destinationUrl) {
	retState = false;
	await getData(destinationUrl)
	.then(data => { tablesData.printerActionResult = data; tablesData.printerIsOnErrorState = false; /*retState = true;*/ })
	//.catch(error => { checkUserSession(error, "warning"); retState = false; });
	// return retState;
}
export async function getAllTablesData() {
	if (tablesToBeRefreshed.users) await getUsers();
	if (tablesToBeRefreshed.locations) await getLocations();
	if (tablesToBeRefreshed.documents) await getDocuments();
	if (tablesToBeRefreshed.referenceItems) await getReferenceItems();
	if (tablesToBeRefreshed.measureUnits) await getMeasureUnits();
	if (tablesToBeRefreshed.additionalBarcodes) await getAdditionalBarcodes();
	if (tablesToBeRefreshed.items) await getItems();
	if (tablesToBeRefreshed.serials) await getSerials();
	if (tablesToBeRefreshed.stocks) await getStocks();
	if (tablesToBeRefreshed.branches) await getBranches();
	if (tablesToBeRefreshed.plants) await getPlants();
	if (tablesToBeRefreshed.customers) await getCustomers();
	if (tablesToBeRefreshed.suppliers) await getSuppliers();
	if (tablesToBeRefreshed.addresses) await getAddresses();
	if (tablesToBeRefreshed.transportMeans) await getTransportMeans();
	if (tablesToBeRefreshed.projectTypologies) await getProjectTypologies();
	if (tablesToBeRefreshed.projects) await getProjects();
	if (tablesToBeRefreshed.projectRows) await getProjectRows();
	if (tablesToBeRefreshed.picks) await getPicks();
	if (tablesToBeRefreshed.tracks) await getTracks();
	if (tablesToBeRefreshed.packageTypologies) await getPackageTypologies();
	if (tablesToBeRefreshed.packages) await getPackages();
	if (tablesToBeRefreshed.printers) getPrinters();
	if (tablesToBeRefreshed.printTemplates) await getPrintTemplates();
}
